// removed by extract-text-webpack-plugin
module.exports = {"content":"_27iWWRCAP_pZV5cgRKu8t6","orderTitle":"_1fWavtRJLFXgqsK0TMdUgM","gridBox":"_12ujGL1lCpcM_oKSMxl5uJ","userChartsBox":"_3hcrqo9LWb2QWFhN1UGqYP"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Index/index.scss
// module id = 1232
// module chunks = 0